import { bootstrap } from '../bootstrap';
bootstrap();

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { AnalyticsService } from 'weavix-shared/services/analytics.service';
import { initializeNewRelic } from 'weavix-shared/utils/initialize-new-relic';

initializeNewRelic();

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));

AnalyticsService.start();
